import React from "react";
const TextInput = ({ id, styles, label, classNames, disabled, value }) => {
  return (
    <div>
      <label htmlFor={id} className="block py-2 sans-regular text-gray-700 dark:text-gray-300 font-medium">
        {label}
      </label>
      <input
        type="text"
        defaultValue={value != null ? value : ""}
        id={id}
        style={{ width: "100%" }}
        className={`${classNames} px-4 py-3 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:focus:ring-indigo-400 dark:focus:border-indigo-400 transition-all`}
        aria-describedby="username-help"
        disabled={disabled}
      />
    </div>
  );
};

export default TextInput;
